import { muiDataGridStarted } from "../apiutils";
import { apiSlice } from "../createApiSlice";

const INTERNALREASON_BASE = "/internalreasons";
const buildUrl = (endpoint) => INTERNALREASON_BASE + endpoint;
const ApiName = "InternalReasons";

const internalReasonApiSlice =  apiSlice.injectEndpoints({
    endpoints: builder => ({
        getInternalReasons: builder.query({
            query: ({ args, invalidate }) => ({
                url: buildUrl(`?page=${args.page}&size=${args.size}`),
                method: 'POST',
                body: args.body,
            }),
            providesTags: (result, error, arg) => [{ type: `${ApiName}` }],
            onQueryStarted: muiDataGridStarted.bind(null, 'getInternalReasons', `${ApiName}`)
        }),
        getInternalReasonsSelect: builder.query({
            query: type => ({
                url: buildUrl(`/select/${type}`),
                method: 'GET'
            }),
            providesTags: (result, error, arg) => [{ type: `${ApiName}Select`}]
        }),
        getInternalReason: builder.query({
            query: id => ({
                url: buildUrl(`/${id}`),
                method: 'GET'
            }),
            providesTags: (result, error, arg) => [{ type: `${ApiName}Single`, id: arg }]
        }),
        addInternalReasons: builder.mutation({
            query: productFieldInfo => ({
                url: buildUrl(`/new`),
                method: 'POST',
                body: productFieldInfo,
            }),
            invalidatesTags: [`${ApiName}`,`${ApiName}Select`],
        }),
        editInternalReasons: builder.mutation({
            query: productFieldInfo => ({
                url: buildUrl(`/${productFieldInfo.id}`),
                method: 'PUT',
                body: productFieldInfo,
            }),
            invalidatesTags: (result, error, arg) => [{ type: `${ApiName}Single`, id: arg.id }, {type: `${ApiName}`},{type: `${ApiName}Select`}],
        }),
        deleteInternalReasons: builder.mutation({
            query: prop => ({
                url: buildUrl(`/${prop.id}`),
                method: 'DELETE',
            }),
            invalidatesTags: (result, error, arg) => [{ type: `${ApiName}Single`, id: arg.id }, {type: `${ApiName}`}, {type: `${ApiName}Select`}],
        }),
    }),
});

export const {
    useGetInternalReasonsQuery,
    useGetInternalReasonQuery,
    useGetInternalReasonsSelectQuery,
    useAddInternalReasonsMutation,
    useEditInternalReasonsMutation,
    useDeleteInternalReasonsMutation
  } = internalReasonApiSlice;
